import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51907888972078:1';
export function GuaranteeSection() {
  const handleCTAClick = () => {
    console.log('InitiateCheckout tracked');
  };
  return <section className="bg-white py-16 px-5" data-id="element-100">
      <div className="max-w-[700px] mx-auto bg-gradient-to-br from-[#FAF7F2] to-[#F0E8DE] rounded-3xl p-10 text-center border-2 border-[rgba(183,110,121,0.2)]" data-id="element-101">
        <div className="text-7xl mb-5" data-id="element-102">🛡️</div>
        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4" data-id="element-103">
          Garantía Total de 30 Días
        </h2>
        <p className="text-base text-[#6B4C3B] font-sans leading-relaxed mb-6" data-id="element-104">
          Prueba el Protocolo B.E.B.E. 365 durante 30 días completos. Si no
          experimentas una mejora notable en el sueño de tu bebé y mayor
          claridad sobre su desarrollo, te devolvemos el 100% de tu dinero. Sin
          preguntas. Sin formularios. Un solo email es suficiente.
        </p>
        <p className="font-bold text-[#B76E79] text-lg mb-6" data-id="element-105">
          El riesgo es completamente nuestro. El futuro es de tu bebé.
        </p>
        <a href={CHECKOUT_URL} onClick={handleCTAClick} className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-lg font-bold py-4 px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse max-w-md" data-id="element-106">
          ⚡ PROBAR SIN RIESGO POR $14.97 →
        </a>
      </div>
    </section>;
}